export const url = "http://13.251.104.71:7050";
// export const url = "http://192.168.5.72:5000"
// export const url = "http://192.168.0.106:5000"
